import {
  currentOrPastDateRangeUI,
  currentOrPastDateSchema,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
const powPeriodOfTimePage = {
  uiSchema: {
    ...titleUI({
      title: content['military-service-pow-period-title'],
      description: content['military-service-pow-period-description'],
    }),
    powDateRange: currentOrPastDateRangeUI(
      {
        title: content['military-service-pow-period-start'],
        monthSelect: false,
      },
      {
        title: content['military-service-pow-period-end'],
        monthSelect: false,
      },
      content['date-error'],
    ),
  },
  schema: {
    type: 'object',
    required: [],
    properties: {
      powDateRange: {
        type: 'object',
        required: [],
        properties: {
          from: currentOrPastDateSchema,
          to: currentOrPastDateSchema,
        },
      },
    },
  },
};

export default powPeriodOfTimePage;
